import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const [result, setResult] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled) return;
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setResult(data); setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      if (attempts.current < 10) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => { cancelled = true; };
  }, [params]);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <>
          <Loader2 size={48} className="text-[#D4AF37] mx-auto mb-6 animate-spin" />
          <h1 className="font-serif-elegant text-3xl font-bold">Vérification du paiement…</h1>
          <p className="text-gray-400 mt-3">Merci de patienter quelques secondes.</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 size={56} className="text-[#009246] mx-auto mb-6" />
          <h1 className="font-serif-elegant text-4xl font-bold">Paiement confirmé !</h1>
          <p className="text-gray-300 mt-4">
            Votre paiement de <span className="text-[#D4AF37]">{result.amount.toFixed(2).replace(".", ",")} €</span> a bien été reçu.
          </p>
          {result.ritas_earned > 0 && (
            <p className="text-lg mt-4" data-testid="payment-ritas-earned">
              🎉 Vous avez gagné <span className="text-[#D4AF37] font-semibold">{result.ritas_earned} RITAS</span> (bonus carte +20% inclus)
            </p>
          )}
          <Link to="/profil" data-testid="payment-back-wallet" className="btn-gold mt-8">Voir mon Wallet RITAS</Link>
        </>
      )}
      {(state === "error" || state === "timeout") && (
        <>
          <XCircle size={56} className="text-[#ff6b81] mx-auto mb-6" />
          <h1 className="font-serif-elegant text-3xl font-bold">{state === "timeout" ? "Vérification en cours" : "Paiement non confirmé"}</h1>
          <p className="text-gray-400 mt-3">
            {state === "timeout"
              ? "Le paiement est en cours de traitement. Vos RITAS seront crédités automatiquement dès confirmation."
              : "Le paiement n'a pas abouti. Aucun montant n'a été débité."}
          </p>
          <Link to="/profil" className="btn-outline-gold mt-8">Retour à mon profil</Link>
        </>
      )}
    </div>
  );
}
